import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  swiperContainer: css`
    position: relative;
    width: 100%;
  `,
  swiper: css`
    width: 100%;

    .swiper-slide {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .swiper-zoom-container {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `,
  flyerImage: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    border: 1px solid #f5f5f5;
  `,
  paginationContainer: css`
    padding: 4px 0px 8px;
    z-index: 2;
  `,

  customPagination: css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    list-style: none;
    padding: 0;
    margin: 0;
    height: ${pxToRem(16)};
  `,
  paginationButton: css`
    background-color: #8e8b8b;
    border: none;
    border-radius: 50%;
    width: ${pxToRem(8)};
    height: ${pxToRem(8)};
    padding: 0px;
    cursor: pointer;
    position: relative;
    outline: none;
    transition: background-color 0.3s ease;
    &:focus-visible {
      box-shadow: 0 0 0 2px #cccccc, 0 0 0 4px ${colors.focusOutlineColor};
    }
  `,
  paginationButtonActive: css`
    background-color: ${colors.prussian};
  `,
};

export default styles;
